export default __webpack_public_path__ + "static/media/herobanner-072021.fdcf20d4.jpg";